'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pickFieldState = undefined;

var _pick2 = require('lodash/fp/pick');

var _pick3 = _interopRequireDefault(_pick2);

var _partial2 = require('lodash/partial');

var _partial3 = _interopRequireDefault(_partial2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.mapStateToProps = mapStateToProps;

var _reactRedux = require('react-redux');

var _capeRedux = require('cape-redux');

var _reduxField = require('redux-field');

var _utils = require('./utils');

var _FieldEditEl = require('./FieldEditEl');

var _FieldEditEl2 = _interopRequireDefault(_FieldEditEl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pickFieldState = exports.pickFieldState = (0, _pick3.default)(['errorMessage', 'hasError', 'suggestion', 'value']);

function mapStateToProps(state, props) {
  var fieldState = (0, _reduxField.getState)(state, props);
  return _extends({}, pickFieldState(fieldState), {
    id: (0, _utils.getFieldId)(props)
  });
}
var getActions = (0, _capeRedux.mapDispatchToProps)(function (_ref) {
  var prefix = _ref.prefix;
  return {
    onChange: (0, _partial3.default)(_reduxField.onChange, prefix),
    onClose: (0, _partial3.default)(_reduxField.clear, prefix)
  };
});

exports.default = (0, _reactRedux.connect)(mapStateToProps, getActions)(_FieldEditEl2.default);


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/Editable/FieldEdit.js
// module id = 672
// module chunks = 0